/**
 * 图片资源集中位置。
 *
 * 远程静态图已下载到 public/images/readdy，运行时只加载本地资源。
 */

const LOCAL_IMAGE_BASE = '/images/readdy';

/** Hero/背景图 */
export const HERO_BG = {
  /** 首页 / 聊天 - 山水（移动端竖版） */
  homeChat: `${LOCAL_IMAGE_BASE}/home-chat.jpg`,
  /** 首页桌面端 - 荷叶·粉荷·独舟 */
  homeDesktop: `${LOCAL_IMAGE_BASE}/home-desktop.jpg`,
  /** 学习任务桌面端 - 荷叶·独舟 */
  tasksDesktop: `${LOCAL_IMAGE_BASE}/tasks-desktop.jpg`,
  /** 诗词背诵桌面端 - 荷花山水(设计稿元素) */
  reciteDesktop: `${LOCAL_IMAGE_BASE}/recite-bg.jpg`,
  /** 经典阅读桌面端 - 竹林山水(设计稿元素) */
  readingDesktop: `${LOCAL_IMAGE_BASE}/reading-bg.jpg`,
  /** 登录启动屏 */
  splash: `${LOCAL_IMAGE_BASE}/splash.jpg`,
  /** 登录主页 */
  login: `${LOCAL_IMAGE_BASE}/login.jpg`,
  /** 个人中心 */
  profile: `${LOCAL_IMAGE_BASE}/profile.jpg`,
  /** 个人中心桌面端 - 荷叶·远山·扁舟（设计稿元素，无水印 v2） */
  profileDesktop: `${LOCAL_IMAGE_BASE}/profile-scene-v2.jpg`,
  /** 任务页 */
  tasks: `${LOCAL_IMAGE_BASE}/tasks.jpg`,
} as const;

/** 中式成就勋章底图（image2 生成：宝相花莲座玉璧章） */
export const BADGE_MEDAL = {
  gold: `${LOCAL_IMAGE_BASE}/badge-medal.png`,
  locked: `${LOCAL_IMAGE_BASE}/badge-medal-locked.png`,
} as const;

/** 朱砂篆刻印章「诗学」（透明底） */
export const SEAL_SHIXUE = `${LOCAL_IMAGE_BASE}/seal-shixue.png`;

/** 我的书斋 · 木书架横板 / 花瓶竹石（设计稿分层元素，透明） */
export const SHELF_BOARD = `${LOCAL_IMAGE_BASE}/shelf-board.png`;
export const SHELF_VASE = `${LOCAL_IMAGE_BASE}/shelf-vase.png`;
/** 我的书斋 · 书脊（多色,按索引轮换,叠竖排书名） */
export const BOOK_SPINES = [
  `${LOCAL_IMAGE_BASE}/book-spine-1.png`,
  `${LOCAL_IMAGE_BASE}/book-spine-2.png`,
  `${LOCAL_IMAGE_BASE}/book-spine-3.png`,
  `${LOCAL_IMAGE_BASE}/book-spine-4.png`,
  `${LOCAL_IMAGE_BASE}/book-spine-5.png`,
  `${LOCAL_IMAGE_BASE}/book-spine-6.png`,
] as const;
/** 我的书斋 · 其余分层元素 */
export const SHELF_STONE = `${LOCAL_IMAGE_BASE}/stone.png`;
export const READING_LOGO = `${LOCAL_IMAGE_BASE}/reading-logo.png`;
export const READING_SEAL = `${LOCAL_IMAGE_BASE}/hero-seal.png`;
export const NOTE_LOTUS = `${LOCAL_IMAGE_BASE}/note-lotus.png`;
/** 我的书斋 · 绿封书本(当前在读立书/封面兜底) + 按钮 + 进度条 */
export const BOOK_COVER = `${LOCAL_IMAGE_BASE}/book-cover.png`;
/** 我的书斋 · 绿竹封硬壳书(在读立书,设计稿元素) */
export const BOOK_GREEN = `${LOCAL_IMAGE_BASE}/book-green.webp`;
export const BTN_GREEN = `${LOCAL_IMAGE_BASE}/btn-green.png`;
export const BTN_GREY = `${LOCAL_IMAGE_BASE}/btn-grey.png`;
export const PROGRESS_BAR = `${LOCAL_IMAGE_BASE}/progress-bar.png`;
/** 我的书斋 · 书架上"继续阅读"卡(绿封书旁,text-blank) */
export const SHELF_CARD = `${LOCAL_IMAGE_BASE}/shelf-card.webp`;
/** 经典阅读 · 书籍概要面板底图(屏B，空白：左封书+中简介概念+右章节框，设计稿) */
export const READING_SUMMARY_PANEL = `${LOCAL_IMAGE_BASE}/reading-summary-panel.webp`;
/** 经典阅读 · 全部书目背景(屏A，宣纸+远山+竹叶角，设计稿) */
export const READING_ALLBOOKS_BG = `${LOCAL_IMAGE_BASE}/reading-allbooks-bg.webp`;
/** 学习任务 · 复习任务弹窗：宣纸背景 + 各分区原图面板(设计稿，已抠白底) */
export const REVIEW_BG = `${LOCAL_IMAGE_BASE}/review-bg.webp`;
export const REVIEW_VIDEO = `${LOCAL_IMAGE_BASE}/review-video.webp`;
export const REVIEW_MATERIALS = `${LOCAL_IMAGE_BASE}/review-materials.webp`;
export const REVIEW_QUOTES = `${LOCAL_IMAGE_BASE}/review-quotes.webp`;
export const REVIEW_QA = `${LOCAL_IMAGE_BASE}/review-qa.webp`;
/** 我的书斋 · 底部四栏卡框(text-blank,叠 CSS 文字) */
export const READING_CARDS = {
  recent: `${LOCAL_IMAGE_BASE}/card-bg-recent.webp`,
  plan: `${LOCAL_IMAGE_BASE}/card-bg-plan.webp`,
  list: `${LOCAL_IMAGE_BASE}/card-bg-list.webp`,
  note: `${LOCAL_IMAGE_BASE}/card-bg-note.webp`,
} as const;
/** 四卡原素材的真实比例(宽/高)，按各自比例渲染不裁切 */
export const READING_CARD_RATIO = { recent: 1185 / 882, plan: 1208 / 899, list: 1190 / 929, note: 1194 / 894 } as const;

/** 诗词背诵 · 学习中空白卡框（设计稿元素，按索引轮换） */
export const RECITE_CARD = [
  `${LOCAL_IMAGE_BASE}/recite-card-bamboo.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-card-cloud.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-card-fan.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-card-lotus.jpg`,
] as const;

/** 诗词背诵 · 左栏荷花水墨（透明，分层元素抠图） */
export const RECITE_SIDEBAR_LOTUS = `${LOCAL_IMAGE_BASE}/recite-lotus2.png`;
/** 诗词背诵 · 折扇（透明，分层元素抠图） */
export const RECITE_FAN = `${LOCAL_IMAGE_BASE}/recite-fan.png`;

/** 诗词背诵 · 列表卡山水缩略图 */
export const RECITE_THUMB = [
  `${LOCAL_IMAGE_BASE}/recite-thumb-1.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-thumb-2.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-thumb-3.jpg`,
  `${LOCAL_IMAGE_BASE}/recite-thumb-4.jpg`,
] as const;

/** 学习任务 · 预习信笺底纹（按主题轮换） */
export const LETTER_BG = [
  `${LOCAL_IMAGE_BASE}/letter-magnolia.jpg`,
  `${LOCAL_IMAGE_BASE}/letter-lotus.jpg`,
  `${LOCAL_IMAGE_BASE}/letter-bamboo.jpg`,
  `${LOCAL_IMAGE_BASE}/letter-ginkgo.jpg`,
  `${LOCAL_IMAGE_BASE}/letter-orchid.jpg`,
  `${LOCAL_IMAGE_BASE}/letter-moon.jpg`,
] as const;

/** 学习任务弹窗 · 卷轴木轴(image2 生成,透明底) */
export const SCROLL_ROD = `${LOCAL_IMAGE_BASE}/scroll-rod.webp`;
/** 学习任务弹窗 · 翻开的精装书(藏青硬壳+米色双页,设计稿元素,透明底) */
export const TASK_BOOK = `${LOCAL_IMAGE_BASE}/task-book.webp`;
/** 学习任务弹窗 · 鎏金描边框(诗卷外框,空心透明) */
export const TASK_GOLD_FRAME = `${LOCAL_IMAGE_BASE}/task-gold-frame.webp`;
/** 学习任务弹窗 · 藏青八角宝相花章(诗词印) */
export const TASK_OCTAGON = `${LOCAL_IMAGE_BASE}/task-octagon.webp`;
/** 学习任务 · 火漆封印(待启卡，做旧氧化暗红熔蜡+压花环+中心留空，透明底) */
export const TASK_WAX_SEAL = `${LOCAL_IMAGE_BASE}/task-wax-seal.webp`;
/** 学习任务 · 已毕钤印(已完成卡，做旧斑驳红方印边框+中心留空，透明底) */
export const TASK_DONE_SEAL = `${LOCAL_IMAGE_BASE}/task-done-seal.webp`;
/** 背诵结果 · 绿勾金环徽章(已背下来，绿勾+鎏金环+祥云，透明底；设计稿元素) */
export const RECITE_DONE_BADGE = `${LOCAL_IMAGE_BASE}/recite-done-badge.webp`;
/** 背诵结果 · 红书本徽章(暂未背下来，红书+鎏金环+祥云+!角标，透明底；设计稿元素) */
export const RECITE_FAIL_BADGE = `${LOCAL_IMAGE_BASE}/recite-fail-badge.webp`;
/** 背诵弹窗 · 宣纸底图卡(竹叶+远山小船+金边角饰；设计稿底图) */
export const RECITE_CARD_BG = `${LOCAL_IMAGE_BASE}/recite-card-bg.webp`;
/** 学习任务弹窗 · 藏青按钮条(完成任务按钮底) */
export const TASK_NAVY_BTN = `${LOCAL_IMAGE_BASE}/task-navy-btn.webp`;
/** 学习任务弹窗 · 引号便签卡(大先生论此诗引文底,含""角标) */
export const TASK_QUOTE_CARD = `${LOCAL_IMAGE_BASE}/task-quote-card.webp`;

/**
 * 学生头像占位图（当学生未上传头像时使用）。
 * 保留参数以兼容现有调用；本地占位图不按尺寸或 seq 生成不同版本。
 */
export function studentAvatarFallback(_size = 96, _seq = 'student-avatar-home'): string {
  return `${LOCAL_IMAGE_BASE}/student-avatar-readdy.jpg`;
}

/** profile 默认头像 */
export const DEFAULT_STUDENT_AVATAR = studentAvatarFallback(192, 'student-avatar-default');

/**
 * 诗词大先生（AI 教师）肖像占位图。
 * 保留参数以兼容现有调用；本地占位图不按尺寸生成不同版本。
 */
export function teacherPortrait(_size = 72): string {
  return `${LOCAL_IMAGE_BASE}/teacher-portrait-readdy.jpg`;
}
